import MultiselectDialog from "./MultiselectDialog.vue";
import swal from "sweetalert";
import { getMeshesBox } from "@/components/anchorage/AnchorageCalculation";
import { getTeethBox, getTeethZoom } from "../occlusal/OcclusalTools.js";
import { drawBox, drawLine, drawPoint } from "../draw/draw.js";
import { isTouchEnabled } from "@/App.vue";

//#region  Fields

let multiselectViewersInitialized = false;

let allTeethBox = null;
let allTeethCenter = null;

let maxillaCenter = null;
let maxillaBox = null;
let maxillaZoom = null;

let mandibleCenter = null;
let mandibleBox = null;
let mandibleZoom = null;

let multiselectScene1 = null;
let multiselectScene2 = null;
let multiselectCamera1 = null;
let multiselectCamera2 = null;
let multiselectControls1 = null;
let multiselectControls2 = null;

const mainColor = "#00FF00";
const opposingColor = "#00FF00";

let view_dy = 3;
let view_dz = 6;
let cameraDistance = 32;

let isUpper1 = false;
let isUpper2 = false;

let controlsInitialized = false;

//#endregion

function setCenters() {
  allTeethBox = offsetBox(getMeshesBox(vueApp.teethMeshes));
  allTeethCenter = new THREE.Vector3(
    allTeethBox.center.x,
    allTeethBox.center.y,
    allTeethBox.min.z + view_dz * 2
  );

  maxillaBox = offsetBox(getTeethBox(true));
  maxillaCenter = new THREE.Vector3(
    maxillaBox.center.x,
    maxillaBox.min.y + view_dy,
    maxillaBox.min.z + view_dz * 2
  );
  maxillaZoom = getTeethZoom(maxillaBox) * 1.2; // / 2;

  mandibleBox = offsetBox(getTeethBox(false));
  mandibleCenter = new THREE.Vector3(
    mandibleBox.center.x,
    mandibleBox.max.y - view_dy * 1.8,
    mandibleBox.min.z + view_dz * 2
  );
  mandibleZoom = getTeethZoom(mandibleBox) * 1.2; // / 2;
}

function initMultiselectViewers() {
  if (!multiselectViewersInitialized) {
    setCenters();

    // $(".multiselect-spinner").css({ display: "block" });
    let containers = ["multiselect1Viewer", "multiselect2Viewer"];

    containers.forEach((containerId, index) => {
      const container = document.getElementById(containerId);
      const scene = createScene(container, index);
      vueApp.allTeeth.forEach((tooth) => {
        let toothMesh = viewer.get_model_mesh(tooth.id);
        let toothGeometry = toothMesh.stitchedGeometry
          ? toothMesh.stitchedGeometry
          : toothMesh.geometry;
        let multiselectMesh = new THREE.Mesh(
          toothGeometry.clone(),
          toothMesh.originalMaterial.clone()
        );
        multiselectMesh.material.color = new THREE.Color("#FFFFFF");
        scene.add(multiselectMesh);
        multiselectMesh.position.copy(toothMesh.position);
        multiselectMesh.rotation.copy(toothMesh.rotation);
        multiselectMesh.visible = true;
        //  toothMesh.visible && tooth.isUpper; // == !index;

        multiselectMesh.model = tooth;
        multiselectMesh.mainMesh = toothMesh;

        if (!toothMesh.multiselectMeshes) {
          toothMesh.multiselectMeshes = [];
        }
        toothMesh.multiselectMeshes.push(multiselectMesh);
      });

      if (isTouchEnabled()) {
        container.addEventListener("touchstart", function (e) {
          var event = e.targetTouches[0];
          onAnchorViewerMouseDown(event, container, scene, index);
        });
      } else {
        container.addEventListener(
          "mousedown",
          function (e) {
            // var event = e.targetTouches[0];
            onAnchorViewerMouseDown(e, container, scene, index);
          },
          false
        );
      }
    });

    switchToMaxilla1();
    switchToMandibular2();

    // $(".multiselect-spinner").css({ display: "none" });
    multiselectViewersInitialized = true;
  }
  multiselectScene1.children
    .concat(multiselectScene2.children)
    .forEach((multiselectMesh) => {
      if (multiselectMesh.model && multiselectMesh.material) {
        let mainMesh = multiselectMesh.mainMesh;
        if (
          !vueApp.allTeeth.includes(multiselectMesh.model) &&
          !viewer.scene.children.includes(mainMesh)
        ) {
          multiselectMesh.visible = false;
          return;
        }

        let isMesh1 = multiselectScene1.children.includes(multiselectMesh);
        multiselectMesh.isSelected = false;
        multiselectMesh.material.color = new THREE.Color("#FFFFFF");

        multiselectMesh.position.copy(mainMesh.position);
        multiselectMesh.rotation.copy(mainMesh.rotation);
        let modelUpper = multiselectMesh.model.isUpper;
        multiselectMesh.visible = isMesh1
          ? modelUpper == isUpper1
          : modelUpper == isUpper2;

        multiselectMesh.material.opacity = multiselectMesh.model.isVisible
          ? 1
          : 0.5;
      }
    });
}

function showMultiselect() {
  // initializeControls();
  $("#multiselectDialog").modal();
  setTimeout(function () {
    initMultiselectViewers();
  }, 300);
}

function switchShow(isShow) {
  let allSelectedMeshes = multiselectScene1.children
    .concat(multiselectScene2.children)
    .filter((m) => m.isSelected);
  console.log("switchShow", isShow, allSelectedMeshes);
  allSelectedMeshes.forEach((mesh) => {
    mesh.material.opacity = isShow ? 1 : 0.5;
    mesh.isVisible = isShow;
  });
}

function multiselectShowOnly() {
  let allSelectedMeshes = multiselectScene1.children
    .concat(multiselectScene2.children)
    .filter((m) => m.isSelected);
  let visibleItems = allSelectedMeshes.map((x) => x.model);

  if (visibleItems.length > 0) {
    $("#multiselectDialog").modal("hide");
    visibleItems.forEach((item) => {
      item.isVisible = true;
      itemVisibilityChanged(item, item.color);
    });
    let invisibleItems = vueApp.allItems.filter(
      (x) => !visibleItems.includes(x)
    );
    invisibleItems.forEach((item) => {
      item.isVisible = false;
      itemVisibilityChanged(item, item.color);
    });

    let visibleMeshes = visibleItems.map((x) => viewer.get_model_mesh(x.id));
    let visibleBox = getMeshesBox(visibleMeshes);
    vueApp.lookAtPoint(visibleBox.center);

    vueApp.$emit("visibilityChanged", "multiselect showOnly");
  } else {
    swal("Please select teeth");
  }
}

function multiselectHide() {
  let allSelectedMeshes = multiselectScene1.children
    .concat(multiselectScene2.children)
    .filter((m) => m.isSelected);

  if (allSelectedMeshes.length > 0) {
    $("#multiselectDialog").modal("hide");
    allSelectedMeshes.forEach((mesh) => {
      let item = mesh.model;
      item.isVisible = false;
      itemVisibilityChanged(item, item.color);
    });

    let visibleItems = vueApp.allItems.filter((x) => x.isVisible);
    let visibleMeshes = visibleItems.map((x) => viewer.get_model_mesh(x.id));
    let visibleBox = getMeshesBox(visibleMeshes);
    vueApp.lookAtPoint(visibleBox.center);

    vueApp.$emit("visibilityChanged", "multiselect hide");
  } else {
    swal("Please select teeth");
  }
}

function multiselectResetVisibility() {
  $("#multiselectDialog").modal("hide");
  vueApp.allTeeth.forEach((item) => {
    item.isVisible = true;
    itemVisibilityChanged(item, item.color);
  });
  // vueApp.unfocusAll();
  // vueApp.resetVisibilityAndOpacity();
  vueApp.switchToDefaultView();
  vueApp.$emit("visibilityChanged", "multiselect reset");
}

//#region Scene

function createScene(container, index) {
  let rect = container.getBoundingClientRect();
  let width = rect.width;
  let height = rect.height;

  const scene = new THREE.Scene();
  if (index === 0) {
    multiselectScene1 = scene;
  } else if (index === 1) {
    multiselectScene2 = scene;
  }
  scene.background = new THREE.Color("#EEF3FF");

  const renderer = new THREE.WebGLRenderer();
  renderer.setSize(width, height);

  const camera = new THREE.PerspectiveCamera(45, width / height, 0.1, 1e4);
  camera.position.x = 20;
  camera.position.z = 50;
  scene.add(camera);
  scene.camera = camera;

  scene.raycaster = new THREE.Raycaster(
    scene.camera.position,
    new THREE.Vector3(0, 0, 0),
    0.1,
    100000
  );

  if (index === 0) {
    multiselectCamera1 = camera;
  } else if (index === 1) {
    multiselectCamera2 = camera;
  }

  addSceneLights(scene, camera);

  // camera.aspect = width / height;
  // camera.updateProjectionMatrix();
  // renderer.setSize(width, height);

  container.appendChild(renderer.domElement);
  const controls = new THREE.AstroControls(camera, renderer.domElement);
  controls.enabled = false;
  if (index === 0) {
    multiselectControls1 = controls;
  } else if (index === 1) {
    multiselectControls2 = controls;
  }
  // scene.add(new THREE.AxesHelper(180));
  // const geometry = new THREE.BoxGeometry(1, 1, 1);
  // const material = new THREE.MeshBasicMaterial({
  //   color: 0xffff00,
  //   wireframe: true,
  // });
  // const cube = new THREE.Mesh(geometry, material);
  // scene.add(cube);

  function animate() {
    requestAnimationFrame(animate);
    renderer.render(scene, camera);
    controls.update();
  }
  animate();
  return scene;
}

function addSceneLights(scene, camera) {
  let ambientLight = new THREE.AmbientLight(0x202020);
  scene.add(ambientLight);

  let dirIntensity = 0.2;
  let directionalLight1 = new THREE.DirectionalLight(0xffffff, dirIntensity);
  directionalLight1.position.x = 1;
  directionalLight1.position.y = 0;
  directionalLight1.position.z = 0;
  scene.add(directionalLight1);

  let directionalLight2 = new THREE.DirectionalLight(0xffffff, dirIntensity);
  directionalLight2.position.x = 1;
  directionalLight2.position.y = 0;
  directionalLight2.position.z = 0;
  scene.add(directionalLight2);

  let directionalLight3 = new THREE.DirectionalLight(0xffffff, dirIntensity);
  directionalLight3.position.x = 0;
  directionalLight3.position.y = 0;
  directionalLight3.position.z = 1;
  scene.add(directionalLight3);

  let directionalLight4 = new THREE.DirectionalLight(0xffffff, dirIntensity);
  directionalLight4.position.x = 0;
  directionalLight4.position.y = 0;
  directionalLight4.position.z = -1;
  scene.add(directionalLight4);

  let pointLight = new THREE.PointLight(0xffffff, 0.55);
  pointLight.position.set(0, 0, 0);
  camera.add(pointLight);
}

//#endregion

//#region Occlusal

function switchToMaxilla1() {
  isUpper1 = true;
  vueApp.allTeeth.forEach((tooth) => {
    let toothMesh = viewer.get_model_mesh(tooth.id);
    if (toothMesh.multiselectMeshes) {
      toothMesh.multiselectMeshes[0].visible =
        toothMesh.visible && tooth.isUpper;
    }
  });

  switchViewerToMaxilla(multiselectCamera1, multiselectControls1);
}

function switchToMandibular2() {
  isUpper2 = false;
  vueApp.allTeeth.forEach((tooth) => {
    let toothMesh = viewer.get_model_mesh(tooth.id);
    if (toothMesh.multiselectMeshes) {
      toothMesh.multiselectMeshes[1].visible =
        toothMesh.visible && !tooth.isUpper;
    }
  });

  switchViewerToMandibular(multiselectCamera2, multiselectControls2);
}

function switchViewerToMaxilla(camera, controls) {
  let teethBox = maxillaBox;
  let teethZoom = maxillaZoom;

  camera.position.x = teethBox.center.x;
  camera.position.y = teethBox.center.y - teethZoom;
  camera.position.z = teethBox.center.z;
  camera.up.y = 0;
  camera.up.x = 0;
  camera.up.z = 1;

  let point = teethBox.center;
  camera.lookAt(point.x, point.y, point.z);
  controls.target = new THREE.Vector3(point.x, point.y, point.z);
}

function switchViewerToMandibular(camera, controls) {
  let teethBox = mandibleBox;
  let teethZoom = mandibleZoom;

  camera.position.x = teethBox.center.x;
  camera.position.y = teethBox.center.y + teethZoom;
  camera.position.z = teethBox.center.z;
  camera.up.y = 0;
  camera.up.x = 0;
  camera.up.z = -1;
  let point = teethBox.center;
  camera.lookAt(point.x, point.y, point.z);
  controls.target = new THREE.Vector3(point.x, point.y, point.z);
}

//#endregion

//#region Events

function onAnchorViewerMouseDown(event, container, scene, viewerIndex) {
  let x = event.offsetX;
  let y = event.offsetY;

  // console.log("onAnchorViewerMouseDown", x, y, container, scene);

  let rect = container.getBoundingClientRect();
  let width = rect.width;
  let height = rect.height;
  let mouse3D = new THREE.Vector3(
    (x / width) * 2 - 1,
    -(y / height) * 2 + 1,
    0.5
  );

  mouse3D.unproject(scene.camera);
  mouse3D.sub(scene.camera.position);
  mouse3D.normalize();

  scene.raycaster.set(scene.camera.position, mouse3D);

  let intersects = scene.raycaster.intersectObjects(scene.children);
  for (const intersect of intersects) {
    let multiselectMesh = intersect.object;
    let tooth = multiselectMesh.model;
    if (tooth && !tooth.extracted && multiselectMesh.visible) {
      let color = viewerIndex === 0 ? mainColor : opposingColor;
      let isSelected = !multiselectMesh.isSelected;

      if (isSelected) {
        let oppositeScene =
          scene == multiselectScene1 ? multiselectScene2 : multiselectScene1;

        let hasOppositeSelected = !!oppositeScene.children.find(
          (c) => c.isSelected && c.model == multiselectMesh.model
        );
        if (hasOppositeSelected) {
          swal("This tooth is already selected on opposite");
          break;
        }
      }

      multiselectMesh.isSelected = isSelected;
      color = multiselectMesh.isSelected ? color : "#FFFFFF";
      multiselectMesh.material.color = new THREE.Color(color);
      break;
    }
  }
}

//#endregion

export {
  showMultiselect,
  switchShow,
  initMultiselectViewers,
  multiselectShowOnly,
  multiselectHide,
  multiselectResetVisibility,
};
